// extracted by mini-css-extract-plugin
export var subtitle = "_bm-2";
export var title = "_bm-0";
export var titleNoWrap = "_bm-1";